import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../base/Button';
import Input from '../base/Input';

export default function Header() {
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/search?q=${encodeURIComponent(searchQuery)}`);
    }
  };

  return (
    <header className="bg-white shadow-sm border-b border-gray-200 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <div 
            className="flex items-center cursor-pointer"
            onClick={() => navigate('/')}
          >
            <div className="w-10 h-10 bg-gradient-to-br from-[#1C1C1C] to-[#D4AF37] rounded-lg flex items-center justify-center ml-3">
              <i className="ri-camera-line text-white text-xl w-6 h-6 flex items-center justify-center"></i>
            </div>
            <h1 className="text-2xl font-bold text-[#1C1C1C] mr-3" style={{ fontFamily: '"Pacifico", serif' }}>
              صورتي
            </h1>
          </div>

          {/* Search Bar */}
          <div className="flex-1 max-w-2xl mx-8">
            <form onSubmit={handleSearch}>
              <Input
                type="text"
                placeholder="ابحث بالمدينة، التصنيف، أو اسم المصور..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                icon="ri-search-line"
                className="text-right"
              />
            </form>
          </div>

          {/* Actions */}
          <div className="flex items-center space-x-4 space-x-reverse">
            <button 
              className="relative p-2 text-gray-600 hover:text-[#D4AF37] transition-colors cursor-pointer"
              onClick={() => navigate('/notifications')}
            >
              <i className="ri-notification-line text-xl w-6 h-6 flex items-center justify-center"></i>
              <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
                3
              </span>
            </button>
            
            <Button
              variant="outline"
              size="sm"
              onClick={() => navigate('/login')}
            >
              تسجيل الدخول
            </Button>
          </div>
        </div>
      </div>
    </header>
  );
}